import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CommonService } from '../../../vass-core/services/common.service';

@Injectable()
export class BeginReviewService {
  constructor(private commonService: CommonService) {}

  generatePDF(): Observable<any> {
    const url = `./assets/mocks/generatePDF.json`;
    return this.commonService.getVerb(url);
  }

  getPDFfipre() {
    const action = sessionStorage.getItem('second-holder')
      ? '/mortgage/holder/secondary/fipre'
      : '/mortgage/fipre';
    const url = `${environment.apiBase}/mortgages/${environment.api_version.mortgages_simulator}${action}`;
    return this.commonService.getVerbFiles(url);
  }

  beginRewiew(body) {
    const url = `${environment.apiBase}/mortgages/${environment.api_version.mortgages_simulator}/mortgage/checks`;
    return this.commonService.postVerb(url, body);
  }
}
